<template>
  <div>
    <div>
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          style="width: 100%"
          border
          v-loading="listLoading"
          @cell-click="toggleSelection"
      >
        <el-table-column property="copyDate" label="时间"/>
        <el-table-column property="" label="被复制数量" class-name="cursor">
          <template #default="scope">
            <p style="color: #3a8ee6">{{ scope.row.copyNum }}次</p>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {marriageWeChatCopyNumList } from '@/api/url'
import { getFormData } from '@/api/api'
import Dialog from "@/assets/js/dialog";
import MarriageCopyUserDialog from "./MarriageCopyUserDialog";


export default {
  name: "MarriageCopyNumDialog",
  props: {
    value: Object
  },
  data() {
    return {
      id: this.value.id,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['id'] = this.id;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(marriageWeChatCopyNumList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {
      //更新用户日志
      if(column.label == '被复制数量') {
        Dialog.open({
          title: '用户列表',
          component: MarriageCopyUserDialog,
          data: {
            id: this.id,
            time: row.copyDate,
            width: '900px'
          },
          close: () => {

          }
        })
      }
    }


  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
